import { TextField, IconButton, InputAdornment } from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import React from "react";
import clipboardCopy from "clipboard-copy"; // Import clipboard-copy
import { toast } from "react-toastify";
import cogoToast from "cogo-toast";

const CustomInput = ({ label, value, setValue, name }) => {
  const handleCopyClick = () => {
    clipboardCopy(value); // Copy the value to the clipboard
    cogoToast.success("Copy to clipboard.", { position: "top-right" });
  };

  return (
    <div style={{ width: "100%", flexDirection: "column" }} className="flex">
      <div style={{ width: "90%" }}>
        <TextField
          margin="normal"
          required
          fullWidth
          label={label}
          value={value}
          name={name}
          onChange={(e) => setValue(e)}
          style={{ marginTop: "5px" }}
          // disabled={true}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleCopyClick} edge="end">
                  <FileCopyIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
    </div>
  );
};

export default CustomInput;
